module.exports = __webpack_public_path__ + "media/src/website/images/locations/felden/felden_04-15f190d654af35c757b8c26dd27c5ddf.jpg";